// Channel name + note localization.
//
// Channel names/descriptions live in the DB as single (Russian) strings. Rather
// than a schema migration + API change, we override the display name/note by
// slug per UI language here, falling back to the DB value when no override
// exists. Currently covers the Walmart category channels (migration 0041);
// extend with Costco/other slugs as needed.

const CHANNELS = {
  "curated-oral-care": {
    name: { ru: "Уход за полостью рта", en: "Oral Care", es: "Cuidado bucal" },
    note: {
      ru: "Зубные пасты, ополаскиватели, щётки, нити. Американские бренды по сниженной цене.",
      en: "Toothpaste, mouthwash, brushes, floss. US brands at a lower price.",
      es: "Pastas dentales, enjuagues, cepillos, hilo dental. Marcas de EE. UU. a precio reducido.",
    },
  },
  "curated-vitamins": {
    name: { ru: "Витамины и БАДы", en: "Vitamins & Supplements", es: "Vitaminas y suplementos" },
    note: {
      ru: "Витаминные комплексы, минералы, омега-3, добавки. Аптечные бренды США.",
      en: "Multivitamins, minerals, omega-3, supplements. US pharmacy brands.",
      es: "Multivitamínicos, minerales, omega-3, suplementos. Marcas de farmacia de EE. UU.",
    },
  },
  "curated-otc": {
    name: { ru: "Аптечка", en: "OTC Medicine", es: "Medicamentos sin receta" },
    note: {
      ru: "Безрецептурные лекарства: обезболивающие, от простуды, аллергии. Американские бренды.",
      en: "Over-the-counter meds: pain relief, cold, allergy. US brands.",
      es: "Medicamentos sin receta: analgésicos, resfriado, alergia. Marcas de EE. UU.",
    },
  },
  "curated-personal-care": {
    name: { ru: "Личная гигиена", en: "Personal Care", es: "Cuidado personal" },
    note: {
      ru: "Дезодоранты, мыло, средства для бритья, шампуни. Бренды США со скидкой.",
      en: "Deodorants, soap, shaving, shampoo. US brands at a discount.",
      es: "Desodorantes, jabón, afeitado, champú. Marcas de EE. UU. con descuento.",
    },
  },
  "curated-toys": {
    name: { ru: "Игрушки", en: "Toys", es: "Juguetes" },
    note: {
      ru: "Игрушки и настольные игры от популярных американских брендов.",
      en: "Toys and board games from popular US brands.",
      es: "Juguetes y juegos de mesa de marcas populares de EE. UU.",
    },
  },
  "curated-snacks": {
    name: { ru: "Снеки и сладости", en: "Snacks & Sweets", es: "Snacks y dulces" },
    note: {
      ru: "Чипсы, печенье, конфеты, протеиновые батончики. Американские бренды.",
      en: "Chips, cookies, candy, protein bars. US brands.",
      es: "Papas fritas, galletas, dulces, barras de proteína. Marcas de EE. UU.",
    },
  },
};

/** Localized channel display name, falling back to the DB name. */
export function chName(ch, lang) {
  return (ch && CHANNELS[ch.slug]?.name?.[lang]) || ch?.name || "";
}

/** Localized channel note/description, falling back to the DB description. */
export function chNote(ch, lang) {
  return (ch && CHANNELS[ch.slug]?.note?.[lang]) || ch?.description || "";
}
